import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetTeamStatisticsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
    team: 'home' | 'away';
}

export const SrWidgetTeamStatistics: FC<SrWidgetTeamStatisticsProps> = ({ matchId, team = 'home', ...props }) => {
    const widgetProps = {
        matchId: matchId,
        team: team,
        limit: 8
    };
    return <SrWidget widgetName="team.leaderboard" widgetProps={widgetProps} {...props} />;
};
